module.exports = __webpack_public_path__ + "media/tulum/wind_god-8792045f.jpg";